import { render, staticRenderFns } from "./PlanCards.vue?vue&type=template&id=2ae477f7&scoped=true&"
import script from "./PlanCards.vue?vue&type=script&lang=js&"
export * from "./PlanCards.vue?vue&type=script&lang=js&"
import style0 from "./PlanCards.vue?vue&type=style&index=0&id=2ae477f7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ae477f7",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VRow})
